export const getUserToken = () => {
  return localStorage.getItem('UserIdToken');
};
export const setUserToken = (token) => {
  localStorage.setItem('UserIdToken', `${token}`);
};
export const unsetUserToken = () => {
  localStorage.removeItem('UserIdToken');
};

export const getUserRefreshToken = () => {
  return localStorage.getItem('UserRefreshToken');
};
export const setUserRefreshToken = (token) => {
  localStorage.setItem('UserRefreshToken', `${token}`);
};
export const unsetUserRefreshToken = () => {
  localStorage.removeItem('UserRefreshToken');
};

export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem('userInfo')) || {};
};
export const setUserInfo = (userInfo) => {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
};
export const unsetUserInfo = () => {
  localStorage.removeItem('userInfo');
};

export const clearStorageWithException = (exceptionKeys) => {
  const allKeys = Object.keys(localStorage);
  allKeys.forEach((key) => {
    if (!exceptionKeys.includes(key)) {
      localStorage.removeItem(key);
    }
  });
};
